import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild
} from '@angular/core';

import { PolicyView } from '@amfam/shared/models';

import '@amfament/embedded-components/policy-view/policy-view.js';

@Component({
  selector: 'app-policy-view-wrapper',
  templateUrl: './policy-view-wrapper.component.html',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PolicyViewWrapperComponent implements OnChanges, AfterViewInit {
  @Input() policyView: PolicyView;
  @Input() mock = false;

  @Output() eventTriggered = new EventEmitter();
  @ViewChild('policyViewComponent') policyViewComponentRef: ElementRef;

  policy = '';
  data = JSON.stringify({ theme: 'base' });

  async ngOnChanges() {
    if (this.policyView) {
      await this.initialize();
    }
  }

  addStylesToShadowDom() {
    const el = document.querySelector('policy-view') as HTMLElement;
    const shadowRoot = el?.shadowRoot;
    if (shadowRoot && 'adoptedStyleSheets' in shadowRoot) {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(`
        @import url('https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined')
        `);
      shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, sheet];
    } else if (shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        @import url('https://fonts.googleapis.com/icon?family=Material+Icons')
        `;
      shadowRoot.appendChild(style);
    }
  }

  ngAfterViewInit(): void {
    this.addStylesToShadowDom();
  }

  onCtaClicked(event) {
    this.eventTriggered.emit({ event, elementRef: this.policyViewComponentRef });
  }

  private async initialize() {
    const policy = { ...this.policyView };
    this.policy = JSON.stringify(policy);
    console.log(this.policy);
  }
}
